<template>
  <node-view-wrapper as="span">
    <v-dialog
        v-model="dialog"
        hide-overlay
        transition="dialog-bottom-transition"
        fullscreen
    >
      <template v-slot:activator="{ on, attrs }">
        <v-card
            class="d-inline-flex px-0 py-0"
            outlined
            tile
        >
          <v-img
              ref="resizableImg"
              :width="node.attrs.width"
              :src="node.attrs.src"
              @click.stop="dialog = true"
          >
          </v-img>
          <v-menu
              v-if="editor.options.editable"
              open-on-hover
              close-delay="1000"
              auto
              offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  class="ml-n5 mt"
              >
                <v-icon small>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-card width="400" class="px-5 py-5" dark height="50">
              <v-row>
                <v-slider
                    v-model="node.attrs.width"
                    class="align-self-stretch mb-n5"
                    min="50"
                    max="1000"
                    step="10"
                    :label="'width:' + node.attrs.width"
                    @change="onChange()"
                ></v-slider>
                <v-btn icon small :href="node.attrs.src" target="_blank">
                  <v-icon>mdi-link</v-icon>
                </v-btn>
              </v-row>
            </v-card>

          </v-menu>
        </v-card>
      </template>
      <v-card>
        <v-img :src="node.attrs.src"></v-img>
      </v-card>
    </v-dialog>
  </node-view-wrapper>
</template>

<script>
import {NodeViewWrapper, nodeViewProps} from '@tiptap/vue-2';

export default {
  components: {
    NodeViewWrapper
  },
  props: nodeViewProps,
  data() {
    return {
      dialog: false,
      activeMenu: false,
    };
  },
  computed: {},
  mounted() {
  },

  methods: {
    onChange() {
      // console.log('onChange', this)
      this.editor.callbacks.update[0]()
    },
  }
};
</script>

<style>

</style>